import { ItemList } from '@/app/models/filters'
import { FiltersAction } from '../actions/filters'

export interface FiltersState {
    departmentList: ItemList[]
    recipientList: ItemList[]
    visibilityList: ItemList[]
    isFullScreen: boolean
    storeIdList: string[]
    distributionList: any
    gettingDistributionList: boolean
    distributionLists: any[]
    gettingDistributionLists: boolean
    savingDistributionLists: boolean
    // filterList: string[]
    storesList: any[]
    macroareas: any[]
    tags: string[]
    photoStatusList: string[]
    storesCount: number
    statusOptionList: ItemList[]
    prioritiesOptionList: ItemList[]
    storesOptionList: StoresOptionsList
    subtypes: {
        news: ItemList[]
        visit: ItemList[]
        task: ItemList[]
    }
    projectTypeOption: Record<string, { label: string; value: string }>
    activityTypes: any[]
    reportTimes: { _id: string; code: string; value: string }[]
    selectedTimeCluster: string
}

export interface StoresOptionsList {
    macroRegion: ItemList[]
    region: ItemList[]
    country: ItemList[]
    coneOfVision?: { macroregion: string; banner: string; country: string }[]
    zone: ItemList[]
    storeLocation: ItemList[]
    city: ItemList[]
    segment: ItemList[]
    host: ItemList[]
    storeHost: ItemList[]
    businessModel: ItemList[]
    banner: ItemList[]
}

export const FILTERS_REDUCER_NAMESPACE = 'filterReducer'

const defaultState: FiltersState = {
    departmentList: [],
    recipientList: [],
    visibilityList: [],
    isFullScreen: false,
    storeIdList: [],
    distributionList: {},
    gettingDistributionList: false,
    distributionLists: [],
    gettingDistributionLists: false,
    savingDistributionLists: false,
    macroareas: [],
    tags: [],
    photoStatusList: [],
    storesList: [],
    storesCount: 0,
    statusOptionList: [],
    prioritiesOptionList: [],
    storesOptionList: {
        macroRegion: [],
        region: [],
        country: [],
        zone: [],
        storeLocation: [],
        city: [],
        segment: [],
        host: [],
        storeHost: [],
        businessModel: [],
        banner: [],
    },
    subtypes: {
        news: [],
        task: [],
        visit: [],
    },
    projectTypeOption: null,
    activityTypes: [],
    reportTimes: [],
    selectedTimeCluster: '',
}

export default (state = defaultState, action: any) => {
    switch (action.type) {
        case FiltersAction.SET_SELECTED_TIME_CLUSTER:
            return { ...state, selectedTimeCluster: action.value }
        case FiltersAction.SET_DEPARTMENT_LIST:
            return {
                ...state,
                departmentList: [...action.value],
            }
        case FiltersAction.SET_PROJECT_TYPE_OPTIONS:
            return {
                ...state,
                projectTypeOption: { ...action.value },
            }
        case FiltersAction.SET_ACTIVITY_TYPES:
            return {
                ...state,
                activityTypes: [...action.value],
            }
        case FiltersAction.SET_RECIPIENT_LIST:
            return {
                ...state,
                recipientList: [...action.value],
            }
        case FiltersAction.SET_VISIBILITY_LIST:
            return {
                ...state,
                visibilityList: [...action.value],
            }
        case FiltersAction.SET_IS_FULLSCREEN:
            return {
                ...state,
                isFullScreen: action.value,
            }
        case FiltersAction.SET_STORE_ID_LIST:
            return {
                ...state,
                storeIdList: [...action.value],
            }
        case FiltersAction.GET_DISTRIBUTION_LISTS_SUCCESS:
            return {
                ...state,
                distributionLists: [...action.value],
                gettingDistributionLists: false,
            }
        case FiltersAction.GET_DISTRIBUTION_LISTS_ERROR:
            return {
                ...state,
                distributionLists: [],
                gettingDistributionLists: false,
            }
        case FiltersAction.GET_DISTRIBUTION_LISTS_REQUEST:
            return {
                ...state,
                gettingDistributionLists: true,
            }
        case FiltersAction.GET_DISTRIBUTION_LIST_SUCCESS:
            return {
                ...state,
                distributionList: action.value,
                gettingDistributionList: false,
            }
        case FiltersAction.GET_DISTRIBUTION_LIST_ERROR:
            return {
                ...state,
                distributionList: {},
                gettingDistributionList: false,
            }
        case FiltersAction.GET_DISTRIBUTION_LIST_REQUEST:
            return {
                ...state,
                gettingDistributionList: true,
            }
        case FiltersAction.SAVE_DISTRIBUTION_LIST_SUCCESS:
            return {
                ...state,
                savingDistributionList: false,
            }
        case FiltersAction.SAVE_DISTRIBUTION_LIST_ERROR:
            return {
                ...state,
                savingDistributionList: false,
            }
        case FiltersAction.SAVE_DISTRIBUTION_LIST_REQUEST:
            return {
                ...state,
                savingDistributionList: true,
            }
        case FiltersAction.GET_FILTERS_SUCCESS:
            return {
                ...state,
                filterList: [...action.value],
            }
        case FiltersAction.DELETE_FILTERS_SUCCESS:
            return {
                ...state,
            }
        case FiltersAction.SET_TYPE_FILTERS_LIST:
            return {
                ...state,
                subtypes: {
                    ...state.subtypes,
                    [action.value?.typeFilter]: [...(action.value?.options ?? [])],
                },
            }
        case FiltersAction.SET_STORES_LIST:
            return {
                ...state,
                storesList: [...action.value],
                storesCount: action.storesCount,
            }
        case FiltersAction.SET_STORES_OPTIONS__LIST:
            return {
                ...state,
                storesOptionList: { ...action.value },
            }
        case FiltersAction.SET_STATUS_LIST_OPTIONS:
            return {
                ...state,
                statusOptionList: [...action.value],
            }
        case FiltersAction.SET_PRIORITIES_LIST_OPTIONS:
            return {
                ...state,
                prioritiesOptionList: [...action.value],
            }
        case FiltersAction.GET_REPORT_TIMES_REQUEST:
            return {
                ...state,
                reportTimes: [],
            }
        case FiltersAction.GET_REPORT_TIMES_SUCCCESS:
            return {
                ...state,
                reportTimes: action.value,
            }
        case FiltersAction.SET_MACROAREA_LIST:
            return {
                ...state,
                macroareas: [...action.value],
            }
        case FiltersAction.SET_PHOTO_STATUS_LIST:
            return {
                ...state,
                photoStatusList: action.value.pictureStatusList,
            }
        case FiltersAction.SET_PHOTO_TAG_LIST:
            return {
                ...state,
                tags: action.value.tags,
            }
        case FiltersAction.APPLY_FILTER_SUCCESS:
        case FiltersAction.APPLY_FILTER_FAILURE:
        case FiltersAction.SHOW_TOAST_EMPTY_FILTER_FAILURE:
        default:
            return {
                ...state,
            }
    }
}
